const styles = theme => ({
  root: {
    margin: '50px 0',
  },
  Dialog: {
    backgroundColor: theme.palette.background.modal,
  },
  logo: {
    objectFit: 'scale-down',
  },
  container: {
    maxWidth: 310,
    margin: '0 auto',
    padding: '35px 0',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16,
  },
  grid: {
    paddingTop: theme.spacing.unit * 4,
  },
  textField: {
    width: 280,
  },
  separator: {
    display: 'flex',
  },
  button: {
    width: 280,
    height: 44,
  },
  error: {
    color: 'red',
  },
  link: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  terms: {
    maxWidth: 280,
  },
  divider: {
    width: 50,
    position: 'relative',
    top: 8,
  },
  o: {
    width: 150,
  },
  facebookButton: {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    padding: '13px 8px 8px 8px',
    boxSizing: 'border-box',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/signup/styles.js